import { Container, Row, Col, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";


export default function Thankyou(): ReactElement {
  const { t } = useTranslation();
  return (
      <div className="heroBanner-pa">
        <section className="my-health-takaful-bnr mt-4">
          <Container className="text-center mt-5">
            <Row className="d-flex justify-content-center">
                <div className="col-12 col-md-6 thanksBox">
                      <img className="thankyouImg" src="../assets/img/thankyouImg.svg" alt="Agent" />
                      <h3 className='thankshead mt-3'>{t("thank")} <span> {t("you")}</span></h3>
                      <p className="thanksParas px-4">{t("sme_thank_you_scheduled_successfully")}</p>
                      <p className="thanksParas px-4">{t("sme_thank_you_takaful_specialist_will_contact_paragraph")} <span> {t("UAN_number")}</span> </p>
                      <Button className="thankyouBtn mb-5">
                        <a className="thankyouAnchor" href="https://takafulbazaar.pk/">{t("back_to_homepage")}</a>
                      </Button>
                </div>
            </Row>
          </Container>
        </section>
      </div>
  );
}
